<template>
  <div id="DownloadComments" class="row">
    <div class="chart-segment-options align-items-start col-2">
        <modal-link modal-id="Show Sentiment Themes" :content-list="pageContent"></modal-link>
        <a href="#!" v-show="!displayDownloadComments" @click="handleToggle">Show Sentiment Themes<i class="fa fa-chevron-down ml-1"></i></a>
        <a href="#!" v-show="displayDownloadComments" @click="handleToggle">Hide Sentiment Themes<i class="fa fa-chevron-up ml-1"></i></a>
    </div>
    <div v-if="displayDownloadComments && !isVerbatimLocked" class="download-comments col-10">
        
        <div class="chart-criteria-section-1-download-comments-section">
          <div class="form-row align-items-start">
            <div class="form-group pl-2 pr-3">
              <div class="d-flex align-items-center">
                <label for="download_commments_period" class="sub-heading-label pr-2 m-0">Start Period</label>
                <div class="theme-select-width">
                  <select
                    id="download_commments_period"
                    name="download_commments_period"
                    class="custom-select required shadow"
                    v-model="download_commments_period"
                  >
                    <option value="">Choose A Time Period</option>
                    <option v-for="(option, idxPeriodOptions) in client_time_periods" v-bind:value="String(option.clientTimePeriodId)" v-bind:key="idxPeriodOptions">
                      {{ option.chartDisplayName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group pl-2 pr-3">
              <div class="d-flex align-items-center">
                <label for="download_commments_end_period" class="sub-heading-label pr-2 m-0">End Period</label>
                <div class="theme-select-width">
                  <select
                    id="download_commments_end_period"
                    name="download_commments_end_period"
                    class="custom-select required shadow"
                    v-model="download_commments_end_period"
                  >
                    <option value="">Choose A Time Period</option>
                    <option v-for="(option, idxPeriodOptions) in client_time_periods" v-bind:value="String(option.clientTimePeriodId)" v-bind:key="idxPeriodOptions">
                      {{ option.chartDisplayName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group pl-2 pr-3">
              <div class="d-flex align-items-center flex-nowrap">
                <label for="number_of_themes" class="sub-heading-label pr-2 m-0 text-nowrap"># of Themes</label>
                <div class="theme-select-width">
                  <select
                    id="number_of_themes"
                    name="number_of_themes"
                    class="custom-select shadow"
                    v-model="number_of_themes"
                  >
                    <option value="0">Select</option>
                    <option v-for="(option, idxNumberOfThemesOptions) in number_of_themes_options" v-bind:value="option.value" v-bind:key="idxNumberOfThemesOptions">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-show="debugMode" class="form-group col-12 col-sm-6 col-lg-4 px-1 mb-2">
              <label for="model" class="sub-heading-label mb-1">Select Model</label>
              <select
                id="model"
                name="model"
                class="custom-select shadow"
                v-model="model"
              >
                <option v-for="(option, idxModelOptions) in model_options" v-bind:value="{ provider: option.provider, name: option.name }" v-bind:key="idxModelOptions">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row align-items-start pt-3 pb-2">
            <div class="form-group pl-2 pr-5">
              <div class="form-check d-flex align-items-center pl-0">
                <input
                  id="includePartialResponses"
                  name="includePartialResponses"
                  type="checkbox"
                  class="position-static m-0"
                  true-value="Y"
                  false-value="N"
                  v-model="themesIncludePartialResponses"
                />
                <label class="form-check-label mb-0 ml-2" for="includePartialResponses">Include Partial Responses</label>
              </div>
            </div>
            <div class="form-group pl-2 pr-5">
              <div class="form-check d-flex align-items-center pl-0">
                <input
                  id="includeExtraResponses"
                  name="includeExtraResponses"
                  type="checkbox"
                  class="position-static m-0"
                  true-value="Y"
                  false-value="N"
                  v-model="themesIncludeExtraResponses"
                />
                <label class="form-check-label mb-0 ml-2" for="includeExtraResponses">Include Extra Verbatim Responses</label>
              </div>
            </div>
          </div>
        </div>
      
      <!-- Action buttons -->        
      <div class="form-row">
          <button class="btn btn-primary float-right ml-2" @click="processComments" :disabled="(processInitiated && !processingComplete)  || deactivateGeneratedThemesButton || oneTimeRunOnlyForInsiderUser">
              <span>Generate Themes</span>
              <span v-show="processInitiated && !processingComplete" class="spinner-border spinner-border-sm"></span>
          </button>   
          <button v-show="debugMode" class="btn btn-primary float-right ml-2" @click="downloadComments" :disabled="deactivateGeneratedThemesButton || oneTimeRunOnlyForInsiderUser">
            <span>Download Verbatims File</span>
          </button> 
      </div>  
      
      <div v-show="oneTimeRunOnlyForInsiderUser" class="form-row pt-1">
          <div v-show="oneTimeRunOnlyForInsiderUser" class="text-danger ml-2">Additional Sentiment Analysis for Verbatims is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
      </div>
      <div v-show="deactivateGeneratedThemesButton" class="form-row pt-1">
          <div v-show="deactivateGeneratedThemesButton" class="text-danger ml-2">Sentiment Analysis for Verbatims is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
      </div>
    </div>
    <!-- Response area -->
     <chart-display-skeleton v-show="!showResults && processingComplete && processInitiated"/>
    <div class="row col-12 ai-comments-tables-wrapper justify-content-center pt-3" v-if="showResults" v-show="displayDownloadComments">
      <div v-if="!isExplorerPage" class="col-10">
        <span style='color:#0070C0'>
          Your positive and negative themes have also been added to your Profile Chart as Gold Stars and Red Flags.
        </span>
      </div>
      <div v-if="!isExplorerPage" class="col-10">
        <span style='color:#7F7F7F; font-family: "Franklin Gothic Medium Cond";'>
           AI-generated insights are based on statistical patterns and may not capture every nuance of sentiment.
        </span>
      </div>
      <!-- Positive Themes Table -->
      <div id="positive-theme-table" class="col-10">
        <div id="positive-themes-data-container" style="border-top: 1px solid #d9d9d9;">
          <div class="chart-header-container d-flex">
            <div class="d-flex title">
              <h4 class="text-primary mt-1 mb-0">
                {{ title }}
              </h4>
            </div>          
          </div>
          <table id="dt_top_positive" cellspacing="0" style="padding-left: 0 !important;">
            <thead>
              <tr>
                <th>Sentiment</th>
                <th v-if="!isExplorerPage">Value Source</th>
                <th v-if="includeValueGaps">Value Gap</th>
                <th>Theme</th>
                <th>Description</th>
                <th>Verbatims</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </div> 
    <!-- Instructions area -->
    <div class="row col-12" v-if="processingComplete && instructions != '' && debugMode">
      <label for="instructions" class="sub-heading-label">Attach the downloaded file and Copy/Paste below instructions to ChatGPT. Verify the output excel file:</label>
      <button @click="copyText" style="margin: auto; margin-right: 10px;">Copy text</button>
      <pre class="json-box" ref="copyDiv">
        {{ formattedInstructions }}
      </pre>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ViewMixins from "../../mixins/ViewMixins.vue";
import WordCloudService from "../../services/word.cloud.service";
import SurveyService from "../../services/survey.service";
import UserService from "../../services/user.service";
import AdminService from "../../services/admin.service";
import ClientTimePeriodService from "../../services/client.time.period.service";
import TableService from "../../services/table.service";
import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import GoogleService from "../../services/google.service";
import NeedsService from "../../services/needs.service";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ClientSettingsService from "../../services/client.settings.service";
import ReportService from "../../services/report.service";
export default {
  name: "DownloadComments",
  mixins: [ContentMixins,ViewMixins,DataTableMixins,AdminMixins,ChartCriteriaMixins,GoogleService],
  components: {ChartDisplaySkeleton},
  data() {
    return {
        clientId: 0,
        title: "Sentiment Themes",
        download_commments_end_period: 0,
        client_time_periods: [],
        number_of_themes: 0,
        number_of_themes_options: [],
        //model: "gpt-5.2",
        model: {
          provider: "gemini",
          name: "gemini-2.5-flash-lite"
        },
        //model_options: ["gpt-5.2", "gpt-4.1", "gpt-4.1-mini", "gpt-4.1-nano"],
        //model_options: ["openai:gpt-5.2", "openai:gpt-4.1", "openai:gpt-4.1-mini", "gemini:gemini-2.5-pro"],
        model_options: [
          { provider: "openai", label: "GPT-5.2", name: "gpt-5.2" },
          { provider: "openai", label: "GPT-4.1", name: "gpt-4.1" },
          { provider: "openai", label: "GPT-4.1 Mini", name: "gpt-4.1-mini" },
          { provider: "gemini", label: "Gemini 2.5 Pro", name: "gemini-2.5-pro" },
          { provider: "gemini", label: "Gemini 2.5 Flash Lite", name: "gemini-2.5-flash-lite" }
        ],
        results: [],
        dtPositive: null,
        dtNegative: null,
        table: {
          id: "dt_top_a",
          class: "table display wrap row-border table-hover",
          configuration: {
            //dom: '<"title-and-table-left"<"table-header"><B>>frtip',    
            dom: '<"w-100"<"d-flex"><B>>frtip',      
            searching: false,
            paging: false,
            pageLength: 25,
            select: true,
            processing: false,
            responsive: false,
            destroy: true,
            info: false,
            order: [],
            ordering: true,
            keys: true,
            sort: false,
            bSortable: false,
            bSort: false,
            buttons: [],
          },
          //columns: TableService.getCommentsAITopResultsTableAttributes(),
        },
        // tableSortBy: [0, "desc"],
        processingComplete: true,
        instructions: "",
        showResults: false,
        displayDownloadComments: false,
        processInitiated: false,
        savedSegments: [],
        clientSettings: {}, 
        needName: null,
        isSavedCard: false,
        deactivateGeneratedThemesButton: false,
        oneTimeRunOnlyForInsiderUser: false,
        includeValueGaps: false,
        themesIncludeExtraResponses: "N",
        themesIncludePartialResponses: "Y"
    };
  },
  props: {
    debugMode: {
      type: Boolean,
      default: true
    },
    isExplorerPage: {
      type: Boolean,
      default: false
    },
    entrySurveyCode: {
      type: String,
      default: SurveyService.getSurveyCode()
    },
    autoGenerateVerbatims: {
      type: Boolean,
      default: false
    },
    clientChart: {
      type: Object,
      default: function() {
        return {};
      }
    },
    clientObject: {
      type: Object,
      default: function() {
        return {};
      }
    },
    inputNeedsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    formattedInstructions() {
      try {
        const parsed = JSON.parse(this.instructions);

        // instructions is an array → take ONLY the first block
        if (Array.isArray(parsed) && parsed.length > 0) {
          //return parsed[0].text;
          return parsed[0].text
            .replace(
              "You will receive input data as a JSON array of objects where each object represents one row.",
              "Sending you a file attached, where"
            )
            .replace(
              "Return ONLY valid JSON (no markdown) in this exact structure:",
              "Return Output in downloadable excel file with ONLY 'topResults' data in this exact structure:"
            );
        }

        return "";
      } catch (e) {
        return "";
      }
    },
    isVerbatimLocked() {
      return this.clientSettings.aiTypeId == 0;
    }
  },
  mounted() {
    this.getClientSettings();
    this.loadData();
    // this.table.columns = this.topResultDtColumns;
  },
  created() {},
  methods: {
    getClientSettings() {
      ClientSettingsService.getClientSettings(this.clientCode, this.setClientSettings, this);
    },
    setClientSettings(response){
      this.clientSettings = ClientSettingsService.parseClientSettings(response.data.data);
      this.displayDownloadComments = (this.isVerbatimLocked || !this.processInitiated) ? false : true;
    },
    handleToggle() {
      if (this.isVerbatimLocked) {
        AdminService.displayErrorMessage({
          text: "Sentiment Analysis for Verbatims is not active for your organization. Contact your W Ratings Advisor for more information."
        });
        return;
      }
      this.toggleDownloadComments();
    },
    createVerbatimData(allData){
        let positiveVerbatimItemForFunctionalNeed = {
          name: "Positive Verbatims",
          needType: "functional",
          needs: []
        }
        let negativeVerbatimItemForFunctionalNeed = {
          name: "Negative Verbatims",
          needType: "functional",
          needs: []
        }
        let positiveVerbatimItemForEmotionalNeed = {
          name: "Positive Verbatims",
          needType: "emotional",
          needs: []
        }
        let negativeVerbatimItemForEmotionalNeed = {
          name: "Negative Verbatims",
          needType: "emotional",
          needs: []
        }

       for (let i = 0; i < allData.length; i++) {
          let sourceVerbatimItem = allData[i];
          let isEmotionalNeed = sourceVerbatimItem.assignedKeyWord == "Trust" || sourceVerbatimItem.assignedKeyWord == "Adaptability" || sourceVerbatimItem.assignedKeyWord == "Activity" || sourceVerbatimItem.assignedKeyWord == "Creativity" || sourceVerbatimItem.assignedKeyWord == "Assurance";
          if (isEmotionalNeed){
            if (sourceVerbatimItem.positiveOrNegative == "Positive"){
              positiveVerbatimItemForEmotionalNeed.needs.push(sourceVerbatimItem.assignedKeyWord);
            } else {
              negativeVerbatimItemForEmotionalNeed.needs.push(sourceVerbatimItem.assignedKeyWord);
            }
          }  else {
            if (sourceVerbatimItem.positiveOrNegative == "Positive"){
              positiveVerbatimItemForFunctionalNeed.needs.push(sourceVerbatimItem.assignedKeyWord);
            } else {
              negativeVerbatimItemForFunctionalNeed.needs.push(sourceVerbatimItem.assignedKeyWord);
            }
          }
       }
      let verbatimsData = [];
      if (positiveVerbatimItemForFunctionalNeed.needs.length > 0){
        verbatimsData.push(positiveVerbatimItemForFunctionalNeed);
      }
      if (negativeVerbatimItemForFunctionalNeed.needs.length > 0){
        verbatimsData.push(negativeVerbatimItemForFunctionalNeed);
      }
      if (positiveVerbatimItemForEmotionalNeed.needs.length > 0){
        verbatimsData.push(positiveVerbatimItemForEmotionalNeed);
      }
      if (negativeVerbatimItemForEmotionalNeed.needs.length > 0){
        verbatimsData.push(negativeVerbatimItemForEmotionalNeed);
      }
      this.$emit("chart-verbatims", verbatimsData);
    },
    copyText() {
      const text = this.$refs.copyDiv.innerText;
      navigator.clipboard.writeText(text);
      AdminService.displayInfoMessage({ text: "Text copied." });
    },
    async loadData() {
      this.processInitiated = false;
      await ClientTimePeriodService.getClientTimePeriodsBySurveyCode(this.entrySurveyCode, this.getClientTimePeriodsBySurveyCodeCallback, this);
    },
    loadCriteriaData() {
      this.savedSegments = [];
      let params = new URLSearchParams(this.clientChart.criteria);
      let auto_process_comments_by_ai = params.get("auto_process_comments_by_ai") || false;
      if (auto_process_comments_by_ai== "true" || auto_process_comments_by_ai== true){
        this.download_commments_period = params.get("download_commments_period") || 0;
        this.download_commments_end_period = params.get("download_commments_end_period") || 0;
        this.number_of_themes = params.get("number_of_themes") || 0;
        this.needName = (params.get("need_name") == null || params.get("need_name") == "null") ? "All" : params.get("need_name");
        this.themesIncludePartialResponses = params.get("themes_include_partial_responses") || "N";
        this.themesIncludeExtraResponses = params.get("themes_include_extra_responses") || "N";
        let segments = params.get("segments");
        if (typeof segments != "undefined" && segments != null && segments != "") {
          try {
            this.savedSegments = JSON.parse(segments);
          } catch (e) {
            var decodedSegments = decodeURIComponent(segments).replace(/\+/g, " ");
            this.savedSegments = $.parseJSON(decodedSegments);
          }
        }
      }
    },
    getClientTimePeriodsBySurveyCodeCallback(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.client_time_periods = response.data.data.clientTimePeriods;
        this.number_of_themes_options = [];
        for (let i = 1; i <= 5; i++) {
          this.number_of_themes_options.push({ value: i, name: i });
        }

      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },    
    processComments: function(){
      if (this.download_commments_period == "" || this.download_commments_period == null || this.download_commments_period == 0) {
        AdminService.displayErrorMessage({ text: "Please select a time period before downloading comments file." });
        return;
      }
      this.processingComplete = false;
      this.processInitiated = true;
      this.$emit("sentiment-themes-generating", true);
      this.$root.processServerRequest("Processing Verbatims");

      let params = new URLSearchParams();
      params.append("client_id", this.clientObject.clientId);
      params.append("survey_id", SurveyService.getSurveyId());
      params.append("user_id", UserService.getUserId());
      params.append("download_commments_period", this.download_commments_period);
      params.append("download_commments_end_period", this.download_commments_end_period);
      params.append("number_of_themes", this.number_of_themes);
      params.append("themes_include_partial_responses", this.themesIncludePartialResponses);
      params.append("themes_include_extra_responses", this.themesIncludeExtraResponses);

      // if(this.debugMode) {
      //   params.append("model", this.model);
      // }
      if (this.debugMode && this.model) {
        params.append("llm_provider", this.model.provider);
        params.append("llm_model", this.model.name);
      }
      if (this.isExplorerPage){
        params.append("is_explorer_page", true);
       if (!this.autoGenerateVerbatims) {
          this.needName = this.$parent.$refs.chartCriteria.$data.displayType;
        }
        params.append("need_name", this.needName);
      }
      params.append("survey_group", this.$parent.$refs.chartCriteria.$data.surveyGroup);
      if(!this.debugMode) {
        params = this.getSegments(params);
      }
      if (this.isSavedCard && this.savedSegments != null && this.savedSegments.length > 0){
        params.append("segments", JSON.stringify(this.savedSegments));
        this.savedSegments = [];
      }
      WordCloudService.processCommentsByAI(params, this.processCommentsCallback);
    },    
    getSegments(params){
      this.criteriaResults = JSON.parse(JSON.stringify(this.$parent.$refs.chartCriteria.$data.criteriaResults));
      let searchParams = new URLSearchParams();
      searchParams = this.buildCriteriaUrl(searchParams);
      let segments = searchParams.get("segments");
      if (typeof segments != "undefined" && segments != null && segments != "") {
         params.append("segments", segments);
      }
      return params
    },
    saveToCard: function(){
        let params = new URLSearchParams();
        params.append("download_commments_period", this.download_commments_period);
        params.append("download_commments_end_period", this.download_commments_end_period);
        params.append("number_of_themes", this.number_of_themes);
        params.append("themes_include_partial_responses", this.themesIncludePartialResponses);
        params.append("themes_include_extra_responses", this.themesIncludeExtraResponses);
        params.append("need_name", this.needName);
        params.append("auto_process_comments_by_ai", true);
        
        this.$emit("save-download-comments-criteria", params);
    },

    processCommentsCallback(response) {
      this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
      this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;
      let statusCode = response.statusCode;
      this.showResults = true;

      if (statusCode == 200) {
        this.saveToCard();
        
        const data = response.data || {};
        const all = (data?.topResults) ? (data.topResults) : [];
        this.instructions = (data?.instructions) ? (data.instructions) : "";
        const finalData = this.includeValueGaps ? this.setValueGaps(all) : all
        this.results = finalData;
        this.createVerbatimData(finalData);
        this.createRecommendationsData(finalData);
        //if (!this.isSavedCard || this.isExplorerPage){
          this.$nextTick(() => {
              this.initResultTables(finalData);
          });
       // }
      } else {
        AdminService.displayErrorMessage({ text: response.message });
        this.instructions = "";
        this.initResultTables([]);
      }
      this.$root.processServerResponse();
      this.processInitiated = false;
      this.processingComplete = true;
      this.$emit("sentiment-themes-generating", false);
    },
    setValueGaps(allData){
      let returnData = [];
      // loop through allData and for each entry create a new node called "valueGap". Set the value by taking the value in the assignedKeyWord field 
      // and looking in the inputNeedsList to find a match using the node "needName". If a match is found then  set valueGap to the value in the node "gap" for that match. If no match is found set valueGap to ''
      for (let i = 0; i < allData.length; i++) {
        let sourceVerbatimItem = allData[i];
        let assignedKeyWord = sourceVerbatimItem.assignedKeyWord;
          let needMatch = this.inputNeedsList.find(need => need.needName === assignedKeyWord);
        if (needMatch) {
          sourceVerbatimItem.valueGap = needMatch.gap;
        } else {
          sourceVerbatimItem.valueGap = '';
        }
        returnData.push(sourceVerbatimItem);
      }
      return returnData;
    },
    initResultTables(all = []) {
        const posSel = "#dt_top_positive";
        
        // destroy if exists
        this.destroyDt(posSel);

        this.table.columns = TableService.getCommentsAITopResultsTableAttributes(this.includeValueGaps);
        if (this.isExplorerPage){
          // remove the Need column
          this.table.columns = this.table.columns.filter(col => col.name !== "assignedKeyWord");
        }
        const baseCfg = $.extend(true, {}, this.table.configuration);
        const cols = this.table.columns;

        // Positive table configuration
        const cfgPos = $.extend(true, {}, baseCfg, {
          data: all,
          columns: cols
        });
        // buttons: use different container ids if you want separate toolbar per table
        $.extend(cfgPos, TableService.getTableButtons(this, "positive-themes-data-container", undefined, undefined, false, "Sentiment Themes"));

        this.$nextTick(() => {
          this.dtPositive = $(posSel).DataTable(cfgPos);
          this.dtPositive.columns.adjust().draw();
        });
    },

    destroyDt(selector) {
      if ($.fn.dataTable.isDataTable(selector)) {
        $(selector).DataTable().destroy();
      }
    },
    getDownloadFilename() {
      return "Verbatims - " + SurveyService.getSurveyName();
    },
    downloadComments: function(){
      if (this.download_commments_period == "" || this.download_commments_period == null || this.download_commments_period == 0) {
        AdminService.displayErrorMessage({ text: "Please select a time period before downloading comments file." });
        return;
      }
      let params = new URLSearchParams();
      params.append("client_id", this.clientObject.clientId);
      params.append("survey_id", SurveyService.getSurveyId());
      params.append("user_id", UserService.getUserId());
      params.append("download_commments_period", this.download_commments_period);
      params.append("download_commments_end_period", this.download_commments_end_period);
      params.append("themes_include_partial_responses", this.themesIncludePartialResponses);
      params.append("themes_include_extra_responses", this.themesIncludeExtraResponses);
      WordCloudService.processComments(params, this.downloadItemCallback);
    },  
    downloadItemCallback(response) {
      this.$root.processServerResponse();
      this.setModalLoading(false);
      const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.getDownloadFilename(); 
      link.download += ".xlsx";
      link.click();
      URL.revokeObjectURL(link.href);
      this.setModalLoading(false);
      AdminService.displaySuccessMessage({ text: "Download Complete" });
    },
    toggleDownloadComments() {
      let label = this.displayDownloadComments ? "close" : "open";
      GoogleService.logClickEvent("Download Verbatims Section Toggle", label, 0, this);         

      this.displayDownloadComments = !this.displayDownloadComments;
    },
    setDefaultValues() {
      this.themesIncludePartialResponses = "Y";
      this.themesIncludeExtraResponses = "N";
    },
    resetValues() {
      this.download_commments_period = 0;
      this.download_commments_end_period = 0;
      this.number_of_themes = 0;
      //this.model = "gpt-5.2";
      this.showResults = false;
      this.processingComplete = true;
      this.processInitiated = false;
      this.instructions = "";
      this.isSavedCard = false;
      this.savedSegments = [];
      this.needName = null;
      this.$emit('sentiments-data', {});
      this.$emit("sentiment-themes-generating", false);
      this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
      this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;
      this.themesIncludeExtraResponses = "N";
    },
    createRecommendationsData(allData) {
      const verbatimsData = {
        themes: allData,
        startPeriod: this.download_commments_period,
        endPeriod: this.download_commments_end_period,
        numberOfThemes: this.number_of_themes == 0 ? 3 : this.number_of_themes,
        themesIncludePartialResponses: this.themesIncludePartialResponses,
        themesIncludeExtraResponses: this.themesIncludeExtraResponses
      };
      this.$emit('sentiments-data', verbatimsData);
    },
    getCommentsTableData() {
      const tableSelector = "#dt_top_positive";
      if ($.fn.dataTable.isDataTable(tableSelector)) {
        const dataTable = $(tableSelector).DataTable();
        return TableService.getTableData(dataTable);
      }
      return [];
    },
    async saveDataForInstantReport(clientReportId) {
      await this.$nextTick();
      const clientId = this.clientObject.clientId;
      const tableData = this.getCommentsTableData();

      await Promise.all([
        ReportService.saveReportTableFileForInstantReport(tableData, "Table - Sentiment Themes", clientId, clientReportId, this.saveReportTableFileCallback, this),
        ReportService.saveInstantReportPage(clientId, TableService.getReportTableContentByTable("dt_top_positive"), "Table - Sentiment Themes", clientReportId, this.title, this.saveReportPageCallback, this)
      ]);
    },    
    saveReportTableFileCallback(response) {},
    saveReportPageCallback(response) {},

  },
  watch: {
    clientChart: function() {
      if (this.clientChart != null && this.clientChart.clientChartId > 0 && this.autoGenerateVerbatims) {
        let params = new URLSearchParams(this.clientChart.criteria);
        this.isSavedCard = params.get("auto_process_comments_by_ai") === "true";
        if (this.isSavedCard) { 
              this.loadCriteriaData();
              if (this.isExplorerPage){
                this.displayDownloadComments = true;
                this.processComments();
              }
        } else {
            this.processingComplete = false;    
        }
      } else {
        this.isSavedCard = false;
        this.processingComplete = false;    
      }
      this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
      this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;
    },
    entrySurveyCode: function(newVal, oldVal) {
      this.getClientSettings();
      this.isSavedCard = false;
      this.resetValues();
      this.loadData();
    },
    includeValueGaps(newVal, oldVal) {
      // Rebuild only if value actually changed
      if (newVal !== oldVal) {
        if (this.isSavedCard) { 
          this.displayDownloadComments = true;
          this.processComments();
        } else {
          this.processingComplete = false;    
        }
      }
    },
    inputNeedsList() {
      this.includeValueGaps = this.inputNeedsList != null && this.inputNeedsList.length > 0;
    },
  },
};
</script>